import React from 'react';
import { DataGrid, GridDensitySelector , GridColumnsToolbarButton, GridFilterToolbarButton, GridToolbarContainer } from '@material-ui/data-grid';
import { GRID_DEFAULT_LOCALE_TEXT } from '../_core/localeTextConstants';
import { ExportCSV } from './ExportCSV';

export const DataGridIndex = (props) => {
  //console.log(props)
  const columns = [
    { field: 'id', headerName: 'ID', width: 90 },
    {
      field: 'firstName',
      headerName: 'First name',
      width: 150,
      editable: true,
    },
    {
      field: 'lastName',
      headerName: 'Last name',
      width: 150,
      editable: true,
    },
    {
      field: 'age',
      headerName: 'Age',
      type: 'number',
      width: 110,
      editable: true,
    },
    {
      field: 'fullName',
      headerName: 'Full name',
      description: 'This column has a value getter and is not sortable.',
      sortable: false,
      width: 160,
      valueGetter: (params) =>
        `${params.row.firstName || ''} ${params.row.lastName || ''}`,
    },
  ];

  return (

    <DataGrid    
      {...props}
      {...{
        autoHeight: true,
        rowHeight:60,
        checkboxSelection: false,
        pageSize: 8,
        components: {
          Toolbar: (x) => <CustomToolbar  {...props} rowsExport={props.rowsExport ? props.rowsExport : props.rows}/>,
          ...props.components, 
        },
        localeText: GRID_DEFAULT_LOCALE_TEXT
      }}
      columns = {props.columns}
    />
  );
}

const CustomToolbar = (props) => {
  return (
    <GridToolbarContainer>
        <GridColumnsToolbarButton />
        <GridFilterToolbarButton  />
        <GridDensitySelector  />
        <GridExportButton {...props} rows={props.rowsExport ? props.rowsExport : props.rows}  />
    </GridToolbarContainer>
  );
 }

const GridExportButton = ({rows, fileName}) => {
  return (
      <ExportCSV csvData={rows} fileName={fileName ? fileName : "exportar"} >Exportar</ExportCSV>
  );
}